// Application Constants
export const CONTACT_INFO = {
  
  
  ADDRESS: 'Jl. Scientia Blvd No.17, Medang, Kec. Pagedangan, Kabupaten Tangerang, Banten 15334'
};

export const COMPANY_INFO = {
  NAME: 'Summarecon Serpong',
  
  POWERED_BY: 'Powered by: PT. Asia Rumah Utama'
};

export const NAVIGATION_LINKS = {
  ABOUT: '/#about',
  RESIDENTIAL: '/#residential',
  APARTEMENT: '/#apartement',
  RUKO: '/#ruko',
  SURROUNDING: '/#surrounding',
  LOCATION: '/#lokasi',
  NAVBAR: '/#navbar',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_CONDITIONS: '/termsandconditions'
};
